// extracted by mini-css-extract-plugin
export default {"btop":"_537ad475da b51b3a094c e44d3183ee","icon":"_6f1cd882b6 _55eb40958a","btoppink":"_4af08cbde1 _8e2256c18e"};